import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return data
      .filter(item => item.person?.public_user?.id)
      .map(item => ({
        id: item.person.public_user.id,
        text: `${item.person.first_name} ${item.person.last_name}`,
      }))
  }, [data]) // eslint-disable-line
}
